export default "/fonts/vendor/katex/dist/KaTeX_Script-Regular.woff?073b3402d036714b43709614d1da717a";